module.exports = __webpack_public_path__ + "img/clogo.27918606.png";